import script from "./ClosingCarryover.vue?vue&type=script&setup=true&lang=js"
export * from "./ClosingCarryover.vue?vue&type=script&setup=true&lang=js"

import "./ClosingCarryover.vue?vue&type=style&index=0&id=7162fc55&lang=less&scoped=true"

import exportComponent from "D:\\cwzl\\cw-net\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7162fc55"]])

export default __exports__